import 'hhsoig-design-system-core/dist/index.css'
import 'hhsoig-design-system-layout/dist/index.css'
import '../../typography.module.css'

import React, { Component } from 'react'
import { hot } from 'react-hot-loader'
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom'

import '../../utilities/fontAwesomeIcons'
import { Header } from '../../components/header'
import { Footer } from '../../components/footer'
import { BadGateway, BadRequest, BadRequestSimple } from '../error'
import {
  Confirmation,
  OpDivConfirmation,
  FugitiveConfirmation
} from '../confirmation'
import { Overview } from '../overview'
import { NotFound } from '../notFound'
import css from './app.module.css'
import { AgentImportPermitComplaint } from '../AgentImportPermitComplaint'
import { ChildSupportComplaint } from '../ChildSupportComplaint'
import { WhistleblowerRetaliationComplaint } from '../WhistleblowerRetaliationComplaint'
import { FeedbackForm } from '../FeedbackForm'
import { FeedbackConfirmation } from '../FeedbackConfirmation'
import { FraudWasteAbuseComplaint } from '../FraudWasteAbuseComplaint'
import { FugitiveComplaint } from '../FugitiveComplaint'
import { GrantContractFraudComplaint } from '../GrantContractFraudComplaint'
import { HealthcareFraudComplaint } from '../HealthcareFraudComplaint'
import {
  IHSChildAbuseComplaint,
  IHSconfirmation
} from '../IHSChildAbuseComplaint'
import { MedicalIdentityTheftComplaint } from '../MedicalIdentityTheftComplaint'
import { OpDivStart, OpDivReferral } from '../OpDivReferral'
import { OtherComplaint } from '../OtherComplaint'
import { QualityOfCareComplaint } from '../QualityOfCareComplaint'
import { ComplaintTypeChoiceForm } from '../ComplaintTypeChoiceForm'
import { loadReCaptcha } from 'react-recaptcha-v3'
import { routePaths as routes } from '../../utilities/routePaths'
import {
  agentImportPermitFraud,
  childSupport,
  fraudWasteAbuse,
  fugitive,
  grantContractFraud,
  healthcareFraud,
  ihsChildAbuse,
  medicalIdTheft,
  opDivReferral,
  otherComplaint,
  qualityOfCare,
  thankYou,
  whistleblowerRetaliation
} from '../../strings/titles'
import { getActiveFeatureSwitches } from '../../utilities/methods/apiHelperMethods'

// Safety check for CSS Modules in Webpack 5
const styles = css || {};

export class App extends Component {
  state = { activeFeatures: [], loadingFeatures: true }

  async componentDidMount() {
    let featureSwitches
    try {
      featureSwitches = await getActiveFeatureSwitches()
      if (featureSwitches && featureSwitches.includes('ENABLE_RECAPTCHA')) {
        loadReCaptcha('6LdDlnoUAAAAAEwiLpwIZTK_DgZkRHkfGu3G3oTc')
      }
    } catch (error) {
      featureSwitches = []
    }
    this.setState({ activeFeatures: featureSwitches || [], loadingFeatures: false })
  }

  banner(text) {
    return (
      <Header title="HHS-OIG" subtitle={<Link to="/">Report {text}</Link>} />
    )
  }

  render() {
    const { activeFeatures, loadingFeatures } = this.state
    const showFeedback = activeFeatures.includes('FEEDBACK')
    const enableIHS = activeFeatures.includes('ENABLE_IHS_FORM')
    
    return (
      <Router>
        {/* We use styles.wrapper with a fallback to a string to prevent undefined errors */}
        <div data-testid="app" className={styles.wrapper || 'app-wrapper'}>
          <div className={styles.content || 'app-content'}>
            <Header
              title="U.S. Department of Health and Human Services"
              subtitle={<Link to="/">Office of Inspector General</Link>}
            />
            <div className="ds-l-container">
              <Switch>
                <Route exact path="/" component={ComplaintTypeChoiceForm} />
                <Route
                  exact
                  path={routes.whistleblower.form}
                  component={WhistleblowerRetaliationComplaint}
                />
                <Route
                  exact
                  path={routes.whistleblower.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={whistleblowerRetaliation}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  path={`${routes.whistleblower.base}/:id?`}
                  component={Overview}
                />
                <Route
                  exact
                  path={routes.agentimportpermitfraud.form}
                  component={AgentImportPermitComplaint}
                />
                <Route
                  exact
                  path={routes.agentimportpermitfraud.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={agentImportPermitFraud}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  exact
                  path={routes.childsupport.form}
                  component={ChildSupportComplaint}
                />
                <Route
                  exact
                  path={routes.childsupport.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={childSupport}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                {showFeedback && (
                  <Route
                    exact
                    path={routes.feedback.form}
                    component={FeedbackForm}
                  />
                )}
                {showFeedback && (
                  <Route
                    exact
                    path={routes.feedback.confirmation}
                    render={props => (
                      <FeedbackConfirmation {...props} docTitle={thankYou} />
                    )}
                  />
                )}
                <Route
                  exact
                  path={routes.fraudwasteabuse.form}
                  component={FraudWasteAbuseComplaint}
                />
                <Route
                  exact
                  path={routes.fraudwasteabuse.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={fraudWasteAbuse}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  exact
                  path={routes.fugitive.form}
                  component={FugitiveComplaint}
                />
                <Route
                  exact
                  path={routes.fugitive.confirmation}
                  render={props => (
                    <FugitiveConfirmation
                      {...props}
                      docTitle={fugitive}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  exact
                  path={routes.grantcontractfraud.form}
                  component={GrantContractFraudComplaint}
                />
                <Route
                  exact
                  path={routes.grantcontractfraud.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={grantContractFraud}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  exact
                  path={routes.healthcare.form}
                  component={HealthcareFraudComplaint}
                />
                <Route
                  exact
                  path={routes.healthcare.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={healthcareFraud}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                {enableIHS && (
                  <Route
                    exact
                    path={routes.ihschildabuse.form}
                    component={IHSChildAbuseComplaint}
                  />
                )}
                {enableIHS && (
                  <Route
                    exact
                    path={routes.ihschildabuse.confirmation}
                    render={props => (
                      <IHSconfirmation
                        {...props}
                        docTitle={ihsChildAbuse}
                        showFeedback={showFeedback}
                      />
                    )}
                  />
                )}
                <Route
                  exact
                  path={routes.medicalidtheft.form}
                  component={MedicalIdentityTheftComplaint}
                />
                <Route
                  exact
                  path={routes.medicalidtheft.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={medicalIdTheft}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route exact path={routes.opdiv.base} component={OpDivStart} />
                <Route
                  exact
                  path={routes.opdiv.form}
                  component={OpDivReferral}
                />
                <Route
                  exact
                  path={routes.opdiv.confirmation}
                  render={props => (
                    <OpDivConfirmation
                      {...props}
                      docTitle={opDivReferral}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  exact
                  path={routes.othercomplaint.form}
                  component={OtherComplaint}
                />
                <Route
                  exact
                  path={routes.othercomplaint.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={otherComplaint}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route
                  exact
                  path={routes.qualityofcare.form}
                  component={QualityOfCareComplaint}
                />
                <Route
                  exact
                  path={routes.qualityofcare.confirmation}
                  render={props => (
                    <Confirmation
                      {...props}
                      docTitle={qualityOfCare}
                      showFeedback={showFeedback}
                    />
                  )}
                />
                <Route exact path={routes.badGateway} component={BadGateway} />
                <Route exact path={routes.badRequest} component={BadRequest} />
                <Route
                  exact
                  path={routes.badRequestSimple}
                  component={BadRequestSimple}
                />
                <Route render={() => <NotFound loading={loadingFeatures} />} />
              </Switch>
            </div>
          </div>
          <Footer
            title="Office of Inspector General"
            subtitle="U.S. Department of Health &amp; Human Services"
          >
            <p data-testid="footer-privacy-policy">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://oig.hhs.gov/notices/privacy-notice.asp"
              >
                Privacy Policy
              </a>
            </p>
            <p data-testid="footer-disclaimers">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.oig.hhs.gov/notices/disclaimers.asp"
              >
                Disclaimers
              </a>
            </p>
          </Footer>
        </div>
      </Router>
    )
  }
}

export default hot(module)(App)